import React, { useState } from 'react'
import { useTheme } from '@mui/material'
import MuiDialog from '@mui/material/Dialog'
import CloseIcon from '@mui/icons-material/Close'
import { DialogTitle, IconButton, Typography, DialogContent } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Transition } from '@e3dc-react/shell/Elements/Dialog/Transition'

interface StyleProps {
  place?: number
  app?: string
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  closeButton: {
    color: theme.palette.common.white,
  },
  dialog: {
    [theme.breakpoints.down('sm')]: {
      padding: 5,
      paddingTop: (props?.place ?? 0) * 15 + 5,
    },
    height: '100%',
    '& .MuiDialog-paper.MuiPaper-root': {
      padding: 0,
      [`${theme.breakpoints.down('md')} and (hover: none)`]: {
        borderRadius: 0,
      },
    },
  },
  dialogTitle: {
    background: `linear-gradient(120.96deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
    color: theme.palette.primary.contrastText,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}))

interface DialogProps {
  title: string | React.ReactElement
  onClose?: () => void
  place?: number
  open: boolean
  confirmClose?: boolean
  children?: React.ReactNode
}

const Dialog: React.FC<DialogProps> = props => {
  const { title, onClose, place } = props
  const [open, setOpen] = useState(true)
  const theme = useTheme()
  const { classes } = useStyles({ place })

  return (
    <MuiDialog
      open={open}
      fullScreen
      fullWidth
      className={classes.dialog}
      TransitionComponent={Transition}
      keepMounted
      TransitionProps={{ onExited: () => onClose?.() }}
      onClose={() => setOpen(false)}
    >
      <DialogTitle variant={theme.typography.dialog} className={classes.dialogTitle}>
        <Typography>{title}</Typography>
        <IconButton className={classes.closeButton} data-qa={'button-modal-close'} onClick={() => setOpen(false)}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{props.children}</DialogContent>
    </MuiDialog>
  )
}

export default Dialog
